module.exports = __webpack_public_path__ + "img/pmg3.3f551622.png";